import { render, staticRenderFns } from "./TicketsSummaryBlock.vue?vue&type=template&id=6815b2f2"
import script from "./TicketsSummaryBlock.vue?vue&type=script&lang=js"
export * from "./TicketsSummaryBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports